import { writable, type Writable } from 'svelte/store';
import type User from '../interfaces/User';

export const user: Writable<User> = writable();
